import CreateOrderDataStore from '../../datastores/CreateOrderDataStore';

export default class CreateOrderDataStoreMock implements CreateOrderDataStore {
  async register() {
    const data = {
      statusCode: '',
      statusMessage: '',
      orderId: '',
      token: '',
      transactionId: ''
    };
    return data;
  }
}
